import { black, gray } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const listForm = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
});

export const contentContainer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});

export const createBtn = style({
  marginTop: space.s16,
  width: 'fit-content',
  marginLeft: 'auto',
});

export const expandableGroup = style({
  display: 'flex',
  flexDirection: 'column',
  marginTop: space.s16,
  gap: space.s12,
});

export const highlightValueContainer = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s8,
  marginBottom: space.s12,
});

export const highlightValueInputContainer = style({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const divider = style({
  height: 1,
  width: '100%',
  marginBottom: space.s12,
  backgroundColor: themeVars.container.border.default,
});

export const addHighlightButton = style({
  marginTop: space.s12,
});

export const regexInput = style({
  marginTop: space.s12,
});

export const colorsContainer = style({
  display: 'flex',
  gap: space.s8,
  alignItems: 'center',
  flexWrap: 'wrap',
});

export const colorPickerContainer = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s8,
  flexWrap: 'wrap',
});

export const colorPickerLabel = style({
  color: themeVars.controls.foreground.label,
  ...typography.labelMd,
});

export const group = style({
  padding: `${space.s12}px ${space.s16}px`,
  borderRadius: space.s16,
  backgroundColor: `light-dark(${gray[100]}, ${black[700]})`,
});

export const expandableSwitchGroupLabel = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
  cursor: 'pointer',
  ...typography.titleMd,
});

// Mixed down the way the terminal tints its success and critical blocks.
const BRAND_TINT = (percent: number) =>
  `color-mix(in oklab, ${themeVars.container.foreground.brand} ${percent}%, transparent)`;

export const matchingSourcesGroup = style({
  padding: `${space.s12}px ${space.s16}px`,
  borderRadius: space.s16,
  backgroundColor: BRAND_TINT(15),
  border: `1px solid ${BRAND_TINT(40)}`,
});

export const matchingSourcesTitle = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
  minWidth: 0,
});

export const matchingSourcesIcon = style({
  width: 18,
  height: 18,
  flexShrink: 0,
  color: themeVars.container.foreground.brand,
});

export const matchingSourcesHint = style([
  typography.bodySm,
  {
    margin: `${space.s4}px 0 0`,
    color: themeVars.container.foreground.secondary,
  },
]);

// The warning belongs to the field above it, not to the form's rhythm.
export const sourcesField = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s6,
});

export const incompatibleSourcesRow = style([
  typography.bodySm,
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: space.s12,
    color: themeVars.color.text.alert.critical,
  },
]);

// A card's own header has nothing below it when closed; the rule sets the
// gap when it does.
export const sectionHeaderLabel = style({
  marginBottom: 0,
});

// Header and children share a heading size, so the rank is drawn, not sized.
export const sectionRule = style({
  height: 1,
  backgroundColor: themeVars.container.border.default,
  margin: `${space.s8}px 0 ${space.s12}px`,
});

export const filterInput = style({
  marginBottom: space.s4,
});
